import { FormErrors } from 'redux-form';
// @ts-ignore
import MESSAGES from 'constants/messages';
// @ts-ignore
import isEmail from 'validator/lib/isEmail';

interface Errors {
  email?: string;
  password?: string;
}

export default ({ email, password }: Errors): FormErrors<Errors> => {
  const errors: FormErrors<Errors> = {};

  if (!email) {
    errors.email = MESSAGES.LOGIN.EMAIL.REQUIRED;
  }

  if (email && !isEmail(email)) {
    errors.email = MESSAGES.LOGIN.EMAIL.VALID;
  }

  if (!password) {
    errors.password = MESSAGES.LOGIN.PASSWORD.REQUIRED;
  }

  return errors;
};
